export default {
  default: {
    error: ``,
    success: ``,
  },
  getUser: {
    error: `Sorry, an error occurred getting your data, please try again`,
    401: `Sorry, you don't have permission to view your user data`,
    404: `Sorry, we couldn't locate your user data`,
  },
  requestEmailVerification: {
    error: `Sorry, an error occurred sending your verification email, please try again`,
    success: `Your verification email has been sent`,
    401: `Sorry, you don't have permission to verify your email`,
  },
};
